import {
  VALIDATION_DOCUMENT_REVIEW_LIST, 
  VALIDATION_DOCUMENT_REVIEW_LIST_SUCCESS, 
  VALIDATION_DOCUMENT_REVIEW_LIST_ERROR,
  VALIDATION_DOCUMENT_REVIEW_SEARCH_SET, 
  VALIDATION_DOCUMENT_REVIEW_SEARCH_CHANGE, 
  VALIDATION_DOCUMENT_REVIEW_PAGE_SET,
  VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT,
  VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  VALIDATION_DOCUMENT_REVIEW_ADD_SET,
  VALIDATION_DOCUMENT_REVIEW_ADD_MODAL_SET,
  VALIDATION_DOCUMENT_REVIEW_ADD,
  VALIDATION_DOCUMENT_REVIEW_ADD_SUCCESS,
  VALIDATION_DOCUMENT_REVIEW_ADD_ERROR,
  VALIDATION_DOCUMENT_REVIEW_ADD_CHANGE,
  VALIDATION_DOCUMENT_REVIEW_DETAIL,
  VALIDATION_DOCUMENT_REVIEW_DETAIL_SUCCESS,
  VALIDATION_DOCUMENT_REVIEW_DETAIL_ERROR,
  VALIDATION_DOCUMENT_REVIEW_VIEW_MODAL_SET,
  VALIDATION_DOCUMENT_REVIEW_EDIT_CHANGE,
  VALIDATION_DOCUMENT_REVIEW_EDIT_MODAL_SET,
  VALIDATION_DOCUMENT_REVIEW_UPDATE,
  VALIDATION_DOCUMENT_REVIEW_UPDATE_SUCCESS,
  VALIDATION_DOCUMENT_REVIEW_UPDATE_ERROR,
  VALIDATION_DOCUMENT_REVIEW_VIEW_TAB_SET,
  VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET,
  VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET_SUCCESS,
  VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET_ERROR,
  VALIDATION_DOCUMENT_REVIEW_UPLOAD_RESET
} from '../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 10
    }
  },
  add: {
      data: {
        new:{ maintenance_flag: false, maintenance_delay_flag: false, event_date: null,  id_delivery_order_line_lot: null, delivery_order_line_lot: null, id_document_type: null}
      },
      modal: false,
      loading: false,
      message: '',
      url: '',
      type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{
      delivery_order_line_lot: false
    },
    value:{
      delivery_order_line_lot: false,
    },
    delivery_order_line_lot:{
      loading: true,
      list:[],
      message: ''
    }
  },
  detail: {
    data: [],
    tab: 'general',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: 'general',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case VALIDATION_DOCUMENT_REVIEW_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case VALIDATION_DOCUMENT_REVIEW_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case VALIDATION_DOCUMENT_REVIEW_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case VALIDATION_DOCUMENT_REVIEW_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          delivery_order_line_lot:{
            ...state.search.delivery_order_line_lot,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          delivery_order_line_lot:{
            ...state.search.delivery_order_line_lot,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          delivery_order_line_lot:{
            ...state.search.delivery_order_line_lot,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new:{ maintenance_flag: false, maintenance_delay_flag: false, event_date: null,  id_delivery_order_line_lot: null, delivery_order_line_lot: null, id_document_type: null}
          },
          modal: action.payload
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
          data: []
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload,
            old: action.payload
          }
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: []
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
      }
    case VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET:
      return { ...state };
    case VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET_SUCCESS:
      return {
        ...state,
        file: [...state.file, action.payload]
      };
    case VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET_ERROR:
      return { 
        ...state,
        file: [...state.file, action.payload]
      };
    case VALIDATION_DOCUMENT_REVIEW_UPLOAD_RESET:
      return {
        ...state,
        file: []
      };
    default:
      return { ...state };
    }

};